var instagram = "//s3.amazonaws.com/edge-assets.lemonade.com/instagram-9f32af78f7c0d9c0fa415fa485349653.svg";

export { instagram as default };
